
import { getReasonType } from "./ReasonTypeAction";

const dispatchGetReasonType = (dispatch: Function) => () => {
    dispatch(getReasonType());
};

const ReasonTypeDispatch = {
    dispatchGetReasonType
};

export default ReasonTypeDispatch